import logo from "../img/logo.png";

export const FooterData =[{
    src:logo,
    li1:"",
    li2:"",
    li3:"info@scorpionsounds.co.uk",
    copy:"©All Rights Reserved 2023",
    li6:""
}]